var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "fill-height my-3 px-1" },
    [
      !_vm.viewedHeader
        ? _c("span", [_vm._v(" " + _vm._s(_vm.text) + " ")])
        : _c("span", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.numberOfViewedControls +
                    "/" +
                    _vm.numberOfAllControls +
                    " " +
                    _vm.text
                ) +
                " "
            ),
          ]),
      _c(
        "v-icon",
        {
          staticClass: "pa-0",
          attrs: { disabled: !_vm.allow_sort },
          on: { click: _vm.toggle_sort },
        },
        [_vm._v(" " + _vm._s(_vm.icon) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }